export enum OfferType {
  FIXED = "fixed",
  PERCENTAGE = "percentage",
  INCENTIVE = "incentive",
}
